import React from 'react'
import { DeleteIcon } from 'components/Material/Icons/Delete'
import { Box } from 'components/Material/index'

interface TrashCanButtonProps {
  onClick: () => void
}

export const TrashCanButton: React.FC<TrashCanButtonProps> = ({ onClick }) => {
  return (
    <Box
      title="Excluir"
      onClick={() => onClick()}
      className="rounded-full bg-blue-bb w-10 h-10 p-2 flex items-center justify-center cursor-pointer"
    >
      <DeleteIcon color="white" />
    </Box>
  )
}
